import React, { useEffect, useState } from 'react'
import Main from '../../cpn/Main'
import { Flex, Space, Table } from 'antd';
import { useShangpinListQuery } from '../../store/dianshangtaizhangApi';
import GoodsEdit from './GoodsEdit';
import GoodsAdd from './GoodsAdd';
import GoodsSpecQuery from '../goodsSpec/GoodsSpecQuery';
function GoodsQuery() {
    const [list, setList] = useState();  
    const {data, isSuccess} = useShangpinListQuery({}, {refetchOnMountOrArgChange: true})
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {sp_id:key,sp_qyt_name,sp_hyt_name,sp_name,sp_content,sp_wz} = item;                 
                    return item = {key,sp_qyt_name,sp_hyt_name,sp_name,sp_content,sp_wz}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.sp_ctime;
                    let bTimeString = b.sp_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'sp_name',
            title: '商品名称',            
            dataIndex: 'sp_name',
        },      
        {
            key: 'sp_content',
            title: '备注',            
            dataIndex: 'sp_content',
        },
        {
            key: 'key',
            title: '编号',            
            dataIndex: 'key',
        },    
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <GoodsEdit sp_id={record.key} sp_name={record.sp_name}/>
                        <GoodsSpecQuery sp_id={record.key} sp_name={record.sp_name}/>
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/GoodsQuery']}>      
            <Flex justify='flex-end'>
                <GoodsAdd />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
            />
        </Main>
    )
}

export default GoodsQuery